import { Redirect } from 'react-router-dom';
import EmployeeList from '../pages/employee-management/employee-list';
import EmployeeInfo from '../pages/employee-management/employee-info';
import BusinessUnitList from '../pages/data-settings/company-structure/business-unit-list';
import DepartmentList from '../pages/data-settings/company-structure/department-list';
import SubDepartmentList from '../pages/data-settings/company-structure/sub-department-list';
import DivisionList from '../pages/data-settings/company-structure/division-list';
import SubDivisionList from '../pages/data-settings/company-structure/sub-division-list';
import SectionList from '../pages/data-settings/company-structure/section-list';
import SubSectionList from '../pages/data-settings/company-structure/sub-section-list';
import LevelEducationList from '../pages/data-settings/education/level-eduction-list';
import InstitutionList from '../pages/data-settings/education/institution-list';
import PositionList from '../pages/data-settings/position/position-list';
import LevelPositionList from '../pages/data-settings/position/level-position-list';
import EmploymentTypeList from '../pages/data-settings/employment-type-list';
import CostCenterList from '../pages/data-settings/cost-center-list';
import UserList from '../pages/admin-settings/user-list';
import Login from '../pages/authentication/login';
import Logout from '../pages/authentication/logout';

const authRoutes = [
    { path: "/employee", component: EmployeeList },
    { path: "/employee/:id", component: EmployeeInfo },
    { path: "/business-unit", component: BusinessUnitList },
    { path: "/department", component: DepartmentList },
    { path: "/sub-department", component: SubDepartmentList },
    { path: "/division", component: DivisionList },
    { path: "/sub-division", component: SubDivisionList },
    { path: "/section", component: SectionList },
    { path: "/sub-section", component: SubSectionList },
    { path: "/level-education", component: LevelEducationList },
    { path: "/institution", component: InstitutionList },
    { path: "/position", component: PositionList },
    { path: "/level-position", component: LevelPositionList },
    { path: "/employment-type", component: EmploymentTypeList },
    { path: "/cost-center", component: CostCenterList },
    { path: "/user", component: UserList },
    {
        path: "/",
        expect: true,
        component: () => <Redirect to="/employee" />,
    }
];

const publicRoutes = [
    { path: "/login", component: Login},
    { path: "/logout", component: Logout},
];

export { authRoutes, publicRoutes };